// Tiny label-wrapper used throughout the send-case form. Lives here (instead
// of being a private helper in Workflow.jsx) so other workflow sub-components
// can share the same field style without prop-drilling JSX.
export function WorkflowField({ label, required, children }) {
    return (
        <label className="block">
            <div className="font-mono-tr text-[10.5px] tracking-[0.22em] uppercase text-slate-500 mb-2">
                {label} {required && <span className="text-rose-500">*</span>}
            </div>
            {children}
        </label>
    );
}
